const $inject = ['moment'];
const lbFutureTime = function (moment) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, elem, attrs, ngModel) {
      let validate = function (viewValue) {
        let dateCompare = attrs.dateCompare ? moment(attrs.dateCompare, 'DD MMM, YYYY').format('DD/MM/YYYY') : undefined;
        let today = dateCompare || moment().add(0, 'day').format('DD/MM/YYYY');
        let selectedDate = moment(attrs.lbFutureTime, 'MMM DD, YYYY').format('DD/MM/YYYY');
        let timeFormat = attrs.timeFormat;
        let inFuture = true;

        if (today === selectedDate) {
          const timeVal = viewValue.value || viewValue;
          let selectedTime = parseInt(moment(timeVal, timeFormat).format('Hmm'));
          let nowTime = 0;

          if (attrs.timeCompare) {
            nowTime = parseInt(moment(attrs.timeCompare, timeFormat).format('Hmm'));
          } else {
            nowTime = parseInt(moment().format('Hmm'));
          }

          inFuture = nowTime < selectedTime;
        }

        if (attrs.required) {
          ngModel.$setValidity('lbFutureTime', inFuture);
        } else {
          ngModel.$setValidity('lbFutureTime', true);
        }

        return viewValue;
      };

      ngModel.$parsers.unshift(validate);
      ngModel.$formatters.push(validate);

      attrs.$observe('lbFutureTime', function () {
        return validate(ngModel.$viewValue);
      });

      attrs.$observe('timeCompare', function () {
        return validate(ngModel.$viewValue);
      });

      attrs.$observe('required', function () {
        if (attrs.required === false) {
          ngModel.$setValidity('lbFutureTime', true);
          return ngModel.$viewValue;
        } else {
          return validate(ngModel.$viewValue);
        }
      });
    },
  };
};

lbFutureTime.$inject = $inject;

export default lbFutureTime;



// WEBPACK FOOTER //
// ./src/directives/lbFutureTime.js